import React, { FC } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Alert,
} from "@mui/material";
import { useTranslation } from "react-i18next";

import { Button } from "@components/base";

interface EducationYearsMissingDialogProps {
  open: boolean;
  onOpenParameters: () => void;
  onCancel: () => void;
}

export const EducationYearsMissingDialog: FC<EducationYearsMissingDialogProps> = ({
  open,
  onOpenParameters,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        {t("paygap.analysisParams.missingYearsTitle", "Missing Education Years")}
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning">
          {t(
            "paygap.analysisParams.missingYearsWarning",
            "Some education items are missing the 'Number of Years' field. Please fill them in before running analysis."
          )}
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="secondary">
          {t("common.cancel", "Cancel")}
        </Button>
        <Button onClick={onOpenParameters} variant="contained" color="primary">
          {t("paygap.analysisParams.openParameters", "Open Analysis Parameters")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
